import styled, { keyframes } from "styled-components";

const searchSkeleton = keyframes`
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
`;

export const StyledSearchContent = styled.div`
  position: relative;
  width: 100%;
  max-height: 88vh;
  overflow: hidden auto;
  padding: 30px;
  color: #eef5fa;
  background: var(--crypto-bg-deep);

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(8, 12, 20, 0.3);
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 999px;
    background: rgba(89, 244, 119, 0.58);
  }

  .close-button-modal {
    top: 22px;
    right: 22px;
  }

  .search-modal-header {
    padding-right: 54px;
    margin-bottom: 22px;
  }

  .search-modal-header span {
    display: inline-flex;
    margin-bottom: 8px;
    color: var(--crypto-green);
    font-size: 12px;
    line-height: 1;
    font-weight: 800;
    letter-spacing: 0.08em;
  }

  .search-modal-header h2 {
    margin: 0;
    color: #ffffff;
    font-family: var(--crypto-display-font);
    font-size: 30px;
    line-height: 1.05;
    font-weight: 700;
    letter-spacing: 0;
  }

  .search-modal-header p {
    margin: 10px 0 0;
    color: #94a6b8;
    font-size: 14px;
    line-height: 1.45;
    font-weight: 500;
  }

  .global-game-search-box {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: 54px;
    border-radius: 12px;
    border: 1px solid var(--crypto-border);
    background: rgba(7, 19, 27, 0.72);
    box-shadow:
      inset 0 1px 0 rgba(255, 255, 255, 0.04),
      0 16px 24px rgba(0, 0, 0, 0.16);
    transition:
      border-color 170ms ease,
      box-shadow 170ms ease,
      background 170ms ease;
  }

  .global-game-search-box:focus-within {
    border-color: rgba(89, 244, 119, 0.7);
    background: rgba(8, 22, 29, 0.9);
    box-shadow:
      0 0 0 3px rgba(89, 244, 119, 0.08),
      0 18px 30px rgba(0, 0, 0, 0.22);
  }

  .global-game-search-box svg {
    flex: 0 0 auto;
    width: 19px;
    height: 19px;
    margin-left: 18px;
    color: #95a9bc;
  }

  .global-game-search-box svg path {
    fill: currentColor;
  }

  .global-game-search-box input {
    width: 100%;
    min-width: 0;
    height: 100%;
    border: 0;
    outline: 0;
    padding: 0 14px;
    color: #f5fbff;
    background: transparent;
    font-size: 15px;
    line-height: 1;
    font-weight: 600;
  }

  .global-game-search-box input::placeholder {
    color: #7f93a7;
  }

  .global-game-search-box button {
    flex: 0 0 auto;
    height: 32px;
    margin-right: 10px;
    border: 0;
    border-radius: 8px;
    padding: 0 12px;
    color: #132016;
    background: var(--crypto-green);
    font-size: 12px;
    line-height: 1;
    font-weight: 800;
    cursor: pointer;
  }

  .search-filter-tabs {
    display: flex;
    gap: 8px;
    overflow-x: auto;
    margin: 18px 0 14px;
    padding-bottom: 4px;
    scrollbar-width: thin;
    scrollbar-color: rgba(89, 244, 119, 0.54) transparent;
  }

  .search-filter-tabs::-webkit-scrollbar {
    height: 4px;
  }

  .search-filter-tabs::-webkit-scrollbar-track {
    background: transparent;
  }

  .search-filter-tabs::-webkit-scrollbar-thumb {
    border-radius: 999px;
    background: rgba(89, 244, 119, 0.54);
  }

  .search-filter-tabs button {
    flex: 0 0 auto;
    height: 38px;
    border: 1px solid var(--crypto-border-soft);
    border-radius: 999px;
    padding: 0 16px;
    color: #a4b4c5;
    background: rgba(7, 19, 27, 0.58);
    font-size: 13px;
    line-height: 1;
    font-weight: 800;
    cursor: pointer;
    transition:
      border-color 160ms ease,
      background 160ms ease,
      color 160ms ease,
      transform 160ms ease;
  }

  .search-filter-tabs button:hover,
  .search-filter-tabs button.is-active {
    border-color: rgba(89, 244, 119, 0.44);
    color: #59f477;
    background: rgba(20, 70, 38, 0.44);
  }

  .search-filter-tabs button:hover {
    transform: translateY(-1px);
  }

  .search-meta-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    min-height: 22px;
    margin-bottom: 12px;
    color: #8da0b4;
    font-size: 12px;
    font-weight: 700;
  }

  .search-meta-row em {
    color: #6fee8c;
    font-style: normal;
    font-weight: 700;
  }

  .search-result-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, 150px);
    justify-content: start;
    gap: 18px 12px;
    min-height: 180px;
    padding: 4px 2px 14px;
  }

  .search-result-card {
    display: block;
    width: 150px;
    border: 0;
    padding: 0;
    color: inherit;
    background: transparent;
    text-align: inherit;
    font: inherit;
    cursor: pointer;
  }

  .result-card {
    position: relative;
    display: block;
    width: 150px;
    aspect-ratio: 5 / 7;
    overflow: hidden;
    border-radius: 8px;
    background:
      linear-gradient(160deg, rgba(89, 244, 119, 0.1), rgba(12, 32, 40, 0.88)),
      var(--crypto-surface-2);
    box-shadow: 0 10px 18px rgba(0, 0, 0, 0.18);
    transform: translateY(0);
    transition:
      transform 0.24s ease,
      box-shadow 0.24s ease;
  }

  .search-result-card:hover .result-card,
  .search-result-card:focus-visible .result-card {
    transform: translateY(-9px);
    box-shadow:
      0 20px 34px rgba(0, 0, 0, 0.34),
      0 0 20px rgba(89, 244, 119, 0.09);
  }

  .search-result-card:focus-visible {
    outline: none;
  }

  .search-result-card:focus-visible .result-card {
    outline: 2px solid rgba(89, 244, 119, 0.66);
    outline-offset: 3px;
  }

  .result-card img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    background: var(--crypto-surface-3);
    transform: scale(1.01);
    transition:
      transform 0.28s ease,
      filter 0.28s ease;
  }

  .search-result-card:hover .result-card img,
  .search-result-card:focus-visible .result-card img {
    filter: blur(2px) brightness(0.58) saturate(1.12);
    transform: scale(1.07);
  }

  .result-card::after {
    content: "";
    position: absolute;
    inset: 0;
    background:
      linear-gradient(180deg, rgba(9, 12, 18, 0.02) 22%, rgba(9, 12, 18, 0.18) 52%, rgba(6, 8, 12, 0.88) 100%);
    pointer-events: none;
    transition: opacity 0.24s ease;
  }

  .search-result-card:hover .result-card::after,
  .search-result-card:focus-visible .result-card::after {
    opacity: 0.9;
  }

  .result-card.no-image {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .result-card.no-image::before {
    content: "";
    position: absolute;
    inset: 13px;
    border-radius: 7px;
    border: 1px solid rgba(89, 244, 119, 0.14);
    background:
      radial-gradient(circle at 22% 18%, rgba(89, 244, 119, 0.2), transparent 32%),
      linear-gradient(135deg, rgba(255, 255, 255, 0.06), transparent);
  }

  .result-badge {
    position: absolute;
    top: 9px;
    left: 9px;
    z-index: 2;
    max-width: calc(100% - 18px);
    border-radius: 999px;
    padding: 5px 8px 4px;
    color: #d9ffe2;
    background: rgba(7, 12, 18, 0.58);
    border: 1px solid rgba(89, 244, 119, 0.24);
    font-size: 10px;
    line-height: 1;
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .result-fallback {
    position: relative;
    z-index: 1;
    color: var(--crypto-green);
    font-family: var(--crypto-display-font);
    font-size: 22px;
    line-height: 1;
    font-weight: 900;
  }

  .result-card.has-image .result-fallback {
    display: none;
  }

  .result-title {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 18px;
    z-index: 2;
    display: flex;
    justify-content: center;
    padding: 0 11px;
    text-align: center;
    transition:
      opacity 0.2s ease,
      transform 0.2s ease;
  }

  .result-title strong,
  .result-hover-layer strong {
    color: #ffffff;
    font-family: var(--crypto-display-font);
    font-size: 15px;
    line-height: 1.18;
    font-weight: 700;
    letter-spacing: 0;
    text-shadow:
      0 2px 8px rgba(0, 0, 0, 0.78),
      0 0 14px rgba(255, 255, 255, 0.08);
    word-break: keep-all;
    overflow-wrap: anywhere;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .result-card.no-image .result-title {
    inset: 0;
    bottom: auto;
    align-items: center;
    padding: 18px;
  }

  .search-result-card:hover .result-title,
  .search-result-card:focus-visible .result-title {
    opacity: 0;
    transform: translateY(10px);
  }

  .result-hover-layer {
    position: absolute;
    inset: 0;
    z-index: 3;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 14px;
    padding: 20px 12px 22px;
    text-align: center;
    background: rgba(6, 18, 24, 0.2);
    opacity: 0;
    transform: translateY(10px);
    transition:
      opacity 0.22s ease,
      transform 0.22s ease;
  }

  .search-result-card:hover .result-hover-layer,
  .search-result-card:focus-visible .result-hover-layer {
    opacity: 1;
    transform: translateY(0);
  }

  .result-hover-layer em {
    max-width: 100%;
    color: #c0cfda;
    font-size: 11px;
    line-height: 1;
    font-style: normal;
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .search-card-play {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #59f477, #25d65f);
    box-shadow:
      0 14px 28px rgba(22, 184, 87, 0.42),
      0 0 24px rgba(89, 244, 119, 0.24),
      inset 0 1px 0 rgba(255, 255, 255, 0.44);
  }

  .search-card-play::before {
    content: "";
    width: 0;
    height: 0;
    margin-left: 4px;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-left: 15px solid #ffffff;
    filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.2));
  }

  .slot-vendor .search-card-play::before {
    width: 14px;
    height: 14px;
    margin-left: 0;
    border: 0;
    border-top: 4px solid #ffffff;
    border-right: 4px solid #ffffff;
    transform: rotate(45deg);
  }

  .search-result-skeleton {
    width: 150px;
    aspect-ratio: 5 / 7;
    border-radius: 8px;
    background: linear-gradient(90deg, rgba(18, 45, 56, 0.74), rgba(31, 64, 76, 0.74), rgba(18, 45, 56, 0.74));
    background-size: 220% 100%;
    animation: ${searchSkeleton} 1.2s ease-in-out infinite;
  }

  .search-state {
    min-height: 110px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 12px;
    padding: 18px;
    color: #91a4b8;
    background: rgba(8, 22, 29, 0.54);
    border: 1px solid var(--crypto-border-soft);
    font-size: 14px;
    font-weight: 700;
  }

  .search-state.is-error {
    min-height: 48px;
    justify-content: flex-start;
    color: #ffb0b0;
    background: rgba(58, 22, 27, 0.32);
    border-color: rgba(255, 112, 112, 0.28);
  }

  @media (max-width: 720px) {
    padding: 22px 16px;

    .search-modal-header h2 {
      font-size: 25px;
    }

    .global-game-search-box {
      height: 48px;
    }

    .search-result-grid {
      grid-template-columns: repeat(auto-fill, minmax(136px, 1fr));
      gap: 16px 10px;
    }

    .search-result-card,
    .result-card,
    .search-result-skeleton {
      width: 100%;
      max-width: 150px;
      justify-self: center;
    }

    .result-title strong,
    .result-hover-layer strong {
      font-size: 14px;
    }
  }
`;

export const StyledModalSidebar = styled.div``;
